import { render, staticRenderFns } from "./msg_message.vue?vue&type=template&id=127f14c4&scoped=true&"
import script from "./msg_message.vue?vue&type=script&lang=js&"
export * from "./msg_message.vue?vue&type=script&lang=js&"
import style0 from "./msg_message.vue?vue&type=style&index=0&id=127f14c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f14c4",
  null
  
)

export default component.exports